import ApiService from "@/core/services/api.service";
// import JwtService from "@/core/services/jwt.service";

//Actions
export const FETCH_CUSTOMS = "fetchCustoms";
export const FETCH_CUSTOM = "fetchCustom";
export const SAVE_CUSTOM = "saveCustom";
export const UPDATE_CUSTOM = "updateCustom";
export const DELETE_CUSTOM = "deleteCustom";

//Mutations
export const SET_ERROR = "setError";
export const SET_LOADING = "setLoadingCustoms";
export const SET_CUSTOMS = "setCustoms";

const state = {
  errors: [],
  customs: [],
  isLoadingCustoms: false
};

const getters = {
  isLoadingCustoms() {
    return state.isLoadingCustoms;
  },
  getCustoms() {
    return state.customs;
  }
};

const actions = {
  [FETCH_CUSTOMS](context, apiParams = "") {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("customs" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [FETCH_CUSTOM](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("customs", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [SAVE_CUSTOM](context, payload) {
    context.commit(SET_LOADING, true);
    const form = payload;
    return new Promise((resolve, reject) => {
      ApiService.post("customs", form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [UPDATE_CUSTOM](context, params) {
    context.commit(SET_LOADING, true);
    const form = params.payload;
    const id = params.id;
    return new Promise((resolve, reject) => {
      ApiService.update("customs", id, form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [DELETE_CUSTOM](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.delete("customs", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  }
};

const mutations = {
  [SET_ERROR](state, errors) {
    state.isLoadingCustoms = false;
    if (Array.isArray(errors)) {
      state.errors = errors;
    } else {
      state.errors = [errors];
    }
  },
  [SET_LOADING](state, value) {
    state.isLoadingCustoms = value;
  },
  [SET_CUSTOMS](state, data) {
    state.isLoadingCustoms = false;
    state.customs = data.data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};